import { FreeSubscription } from "@/common/model/FreeSubscription";
import { FreeSubscriptionRequestDTO } from "@/common/model/dto/request/FreeSubscriptionRequest.dto";
import { FreeSubscriptionResponseDTO } from "@/common/model/dto/response/FreeSubscriptionResponse.dto";
import { formatDateForInput, parseToBackendDate } from "@/helpers/date.helper";
import { getFreeSubscriptionStatus } from "@/helpers/free-subscription.helper";

export class FreeSubscriptionMapper {
  static fromResponse(dto: FreeSubscriptionResponseDTO): FreeSubscription {
    if (!dto) {
      throw new Error(
        "FreeSubscriptionMapper {: DTO is undefined. Cannot map FreeSubscription."
      );
    }
    const deletedAt = dto.deletedAt === "N/A" ? null : new Date(dto.deletedAt!);
    return {
      id: dto.id,
      userId: dto.userId,
      userName: dto.userName,
      userEmail: dto.userEmail,
      startDate: new Date(dto.startDate),
      endDate: new Date(dto.endDate),
      fromMigration: dto.fromMigration,
      observations: dto.observations,
      grantedBy: dto.grantedBy,
      grantedByUserName: dto.grantedByUserName,
      status:
        deletedAt !== null
          ? "deleted"
          : getFreeSubscriptionStatus(
              new Date(dto.startDate),
              new Date(dto.endDate)
            ),
      deletedAt,
      subscriptionType: dto.subscriptionType,
    };
  }

  static toRequest(
    subscription: Partial<FreeSubscription>
  ): FreeSubscriptionRequestDTO {
    if (!subscription.subscriptionType) {
      throw new Error("FreeSubscriptionMapper: subscriptionType is required");
    }
    return {
      observations: subscription.observations || undefined,
      subscriptionId: subscription.id || undefined,
      startDate: parseToBackendDate(formatDateForInput(subscription.startDate)),
      endDate: parseToBackendDate(formatDateForInput(subscription.endDate)),
      userId: subscription.userId || undefined,
      subscriptionType: subscription.subscriptionType,
    };
  }
}
